// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb5295b6","453":"513f6c27","455":"5ecf1cae"}[chunkId] + ".chunk.js";
};